import { createContext, useState } from "react"

export const DContext = createContext()
export default function DataContext(props) {
    const [openForm, setOpenForm] = useState(false);

    const data ={openForm, setOpenForm}

  return (
      <DContext.Provider value={data} >
          {props.children}
    </DContext.Provider>
  )
}

